import React from "react";
import ManagementToolbar from "../../../../../components/reusable/management/ManagementToolbar";
// import "../../../../../css/pages/ca_pages/teams/employees_model/EmployeeToolbar.css";

const EmployeeToolbar = ({
    filters = {
        search: "",
        office: "",
        status: "",
        department: "",
    },

    filterOptions = {
        offices: [],
        departments: [],
    },

    employeeCount = 0,
    onChange,
    onReset,
}) => {

    // FILTER OPTIONS
    const officeOptions =
        Array.isArray(filterOptions?.offices)
            ? filterOptions.offices
            : [];

    const departmentOptions =
        Array.isArray(filterOptions?.departments)
            ? filterOptions.departments
            : [];

    // STATUS OPTIONS
    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
    ];

    // CHANGE HANDLER
    const handleChange = (nextFilters) => { onChange?.(nextFilters); };

    return (
        // <div className="employee-toolbar">
        //     <div className="employee-toolbar-top">
        //         <div className="employee-search">
        //             <span>🔍</span>
        //             <input type="text" placeholder="Search employee..." />
        //         </div>
        //     </div>

        //     <div className="employee-toolbar-bottom">
        //         <div className="employee-filters">
        //             <select>
        //                 <option>Status</option>
        //                 <option>Working</option>
        //                 <option>Available</option>
        //                 <option>On Leave</option>
        //                 <option>Offline</option>
        //             </select>

        //             <select>
        //                 <option>Department</option>
        //             </select>

        //             <select>
        //                 <option>Office</option>
        //             </select>

        //             <select>
        //                 <option>Role</option>
        //             </select>

        //             <button className="reset-btn">Reset</button>
        //         </div>

        //         <div className="employee-count">
        //             Showing
        //             <strong> 18 </strong>
        //             Employees
        //         </div>
        //     </div>
        // </div>

        <ManagementToolbar
            values            = { filters }
            searchPlaceholder = "Search employees..."
            filters           = {[
                {
                    key:         "office",
                    label:       "Office",
                    placeholder: "All Offices",
                    options:     officeOptions,
                },
                {
                    key:         "status",
                    label:       "Status",
                    placeholder: "All Statuses",
                    options:     statusOptions,
                },
                {
                    key:         "department",
                    label:       "Department",
                    placeholder: "All Departments",
                    options:     departmentOptions,
                },
            ]}

            onChange          = { handleChange }
            onReset           = { onReset }
            resultCount       = { employeeCount }
            resultLabel       = "employees"
            showCount
        />
    );
};

export default EmployeeToolbar;
